import { useMutation, useQueryClient } from '@tanstack/react-query'

import client from '~/clients/api-client'
import { trackViewOptionProfileUserEvent } from '~/hooks/useViewOptionProfile'

import { handleApiRequest } from '../../optimus/shared/apiWrapper'

export const useSelectViewOptionProfileMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (id: number) => handleApiRequest(() => client.viewOptionProfiles.select(id)),
        retry: 0,
        onSuccess: async response => {
            // invalidate view option profiles list query to refetch updated profiles
            await queryClient.invalidateQueries({ queryKey: ['viewOptionProfiles'] })
            void trackViewOptionProfileUserEvent('SELECTED_VIEW_OPTION_PROFILE', response)
        },
    })
}
